import { get, assign } from 'lodash';
import SaveToWorkspace from '@patsnap-biz/save-to-workspace-v2';
import { Toast } from 'patsnap-biz';
import {
    DEFAULT_CONFIG,
} from 'library-@/config/save-to-workspace-config';
import { transformSelectSeqs } from 'library-@/apis/life_science_api/life_science';

import '@patsnap-biz/save-to-workspace-v2/lib/style';

const { SaveSequenceSubjectToWorkspace, SequenceSubjectService } = SaveToWorkspace;

export default {
    name: 'SaveSequenceToWS',
    props: {
        selectedSeqs: {
            type: Object,
            required: true,
        },
        taskId: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            service: null,
        };
    },
    created() {
        function generateName() {
            // 如果是从文本里hover的序列，从勾选序列取
            const seqNo = get(this.selectedSeqs, 'selectedSeqs[0].sequence_no');
            if (seqNo) {
                return `${this.selectedSeqs.pn}-${seqNo || get(this.selectedSeqs, 'location.SEQ_ID', [0]).join()}`;
            } else {
                const code = get(this.selectedSeqs, 'selectedSeqs[0].sequence_id')
                return `Seq Code ${code}`
            }
        }
        class Service extends SequenceSubjectService {
            constructor(vm) {
                super();
                this.vm = vm;
                assign(this, DEFAULT_CONFIG);
                this.enableRange = false;
                this.enableFamily = false;
                this.enableAutoUpdate = false;

                // 选中的序列信息
                this.selectedObj = {
                    // isExclude: vm.selectedSeqs.isExclude,
                    // excludeSeqs: vm.selectedSeqs.excludeSeqs.map((x) => x.sequence_id),
                    selectedSeqs: (vm.selectedSeqs.selectedSeqs || []).map((x) => x.sequence_id),
                    selectedCount: vm.selectedSeqs.selectedCount,
                    seqName:
                        vm.selectedSeqs.selectedCount === 1 && !vm.selectedSeqs.extractQuery
                            ? generateName.bind(vm)()
                            : '',
                    searchType: vm.selectedSeqs.searchType,
                    from_module: vm.selectedSeqs.from_module,
                    pn: vm.selectedSeqs.pn,
                    location: vm.selectedSeqs.location,
                    extractQuery: vm.selectedSeqs.extractQuery,
                    patentId: vm.selectedSeqs.patentId,
                };
                // eslint-disable-next-line
                this.taskId = vm.taskId;

                this.init();
            }

            async generateSubmitSaveToWorkspaceParams() {
                // 如果是一条序列，不用转queryId
                let queryId = '';
                const isOneSeq = this.selectedObj.selectedCount === 1 && !this.selectedObj.extractQuery;
                if (!isOneSeq) {
                    queryId = await transformSelectSeqs({
                        patent_id: this.selectedObj.patentId,
                        extract_query: this.selectedObj.extractQuery,
                        from_module: this.selectedObj.from_module,
                    });
                }

                const oneSeqId = get(this.selectedObj, 'selectedSeqs[0]', '');

                const params = {
                    data_count: this.selectedObj.selectedCount,
                    // 如果是一条填这个字段
                    data_ids: queryId ? [] : this.selectedObj.selectedSeqs,
                    data_type: this.type,
                    extra_info: isOneSeq
                        ? {
                            [oneSeqId]: {
                                sequence_name: this.selectedObj.seqName,
                                history: [
                                    {
                                        sequence_number: oneSeqId,
                                        pn: this.selectedObj.pn,
                                        location: this.selectedObj.location,
                                        created_at: Date.now(),
                                        type: 'PATENT',
                                    },
                                ],
                            },
                        }
                        : {},
                    range: !isOneSeq,
                    range_params: {
                        query_id: queryId,
                    },
                };

                return params;
            }

            // 用于i18n
            t(...params) {
                return this.vm.$t(...params);
            }

            onToastError({ message }) {
                Toast({ message, type: 'error' });
            }

            onClose(success) {
                // 触发时机：
                // 1. 用户提交，并且接口正常完成以后。
                // 2. 用户点击弹窗右上角叉叉时。
                // 3. 用户点击弹窗右下角取消按钮时。
                if (success) {
                    const { template } = success;
                    Toast.closeAll();
                    Toast({
                        type: 'success',
                        message: template,
                        dangerouslyUseHTMLString: true,
                        duration: 5000,
                        showClose: true,
                    });
                }
                this.vm.$emit('close');
            }
        }
        this.service = new Service(this);
    },

    render() {
        return (
            <div>
                {this.service ? (
                    <SaveSequenceSubjectToWorkspace service={this.service}></SaveSequenceSubjectToWorkspace>
                ) : null}
            </div>
        );
    },
};
